import { useState, useCallback } from "react";

import { LendingStrategyPagination, StrategyExpanded, StrategySortType } from "@bridgesplit/abf-react";
import { All, SortDirection } from "@bridgesplit/utils";

import { getPrincipalMints, useChunkedPaginationController } from "./shared";

const DEFAULT_PAGE_SIZE = 5;

export function useLenderStrategiesPagination() {
    const [showArchived, setShowArchived] = useState<boolean>(false); //showArchived

    const [principalMint, setPrincipalMint] = useState<string | undefined | All>(undefined);
    const [sortDirection, setSortDirection] = useState<SortDirection>(SortDirection.Desc);
    const [sortType, setSortType] = useState<StrategySortType>(StrategySortType.NetAssetValue);

    const chunkedPagination = useChunkedPaginationController<StrategyExpanded, LendingStrategyPagination>(
        {
            userAddress: undefined,
            principalMints: getPrincipalMints(principalMint),
            addresses: [],
            showArchived,
            sortDirection,
            sortType
        },
        DEFAULT_PAGE_SIZE
    );

    const reset = useCallback(() => {
        setShowArchived(false);
        setPrincipalMint(undefined);
        chunkedPagination.resetPagination();
    }, [chunkedPagination]);

    return {
        ...chunkedPagination, //Backend pagination params
        params: chunkedPagination.clientPagination, //Client pagination params
        setShowArchived,
        setPrincipalMint,
        setSortDirection,
        setSortType,
        reset
    };
}
